"use client"

const Logo = ({ className = "", width = 120, height = 60 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M37.0024 0.946045L36.9688 1.02501V1.03354L37.0024 0.946045Z" fill="currentColor" />
      <path d="M52.4023 23.4972L52.4163 23.5281L52.4302 23.4929L52.4023 23.4972Z" fill="currentColor" />
      <mask
        id="mask0_3147_16711"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="2"
        width="100"
        height="58"
      >
        <path d="M110 2.82495H10V59.054H110V2.82495Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3147_16711)">
        <path
          d="M99.824 7.49986L94.348 23.3389L102.302 45.1929H97.339L92.088 28.8199L86.365 45.1909H81.957C85.804 34.6299 93.532 13.3949 97.379 2.82886H102.306L109.999 23.9599L105.04 23.9709L99.824 7.49986Z"
          fill="currentColor"
        />
        <path d="M89.6626 24.0261L89.6516 24.0581L89.6406 24.0311L89.6626 24.0261Z" fill="currentColor" />
        <path
          d="M43.281 7.49195L48.471 23.937L53.43 23.929L45.754 2.82495H40.829C40.788 2.94395 35.638 17.125 35.6 17.241L30.362 2.82495H25.378C21.547 13.391 13.832 34.625 10 45.191H14.408L20.135 28.725L25.36 45.195H29.86L30.091 44.563L35.557 28.817L40.787 45.195H45.749L37.824 23.378C37.838 23.343 43.268 7.52395 43.281 7.49195ZM27.881 38.492C27.873 38.465 22.391 23.409 22.381 23.372L27.844 7.47195L33.109 24.108L27.881 38.492Z"
          fill="currentColor"
        />
        <path
          d="M63.8158 7.48186L58.3528 23.3249L66.3118 45.1889L61.3528 45.1939L56.1088 28.8249L50.3748 45.1679H45.9648C49.8188 34.5929 57.5358 13.3989 61.3888 2.82886H66.3158L73.9928 23.9289L69.0338 23.9369L63.8158 7.48186Z"
          fill="currentColor"
        />
        <path
          d="M92.0309 2.87248C86.0059 19.3265 77.5769 42.6405 71.6149 59.0555H67.2419L72.0939 45.2285C72.0939 45.2285 65.3449 28.3135 63.9609 24.1285H68.4609C68.4609 24.1425 74.1109 40.1455 74.1159 40.1635L79.7999 23.9215C77.9999 19.7325 73.0249 7.00148 71.6249 2.84448H76.1249C76.1249 2.85848 81.9469 18.6005 81.9519 18.6185L87.5959 2.87248H92.0309Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export default Logo
